import { For, type JSX, Show } from 'solid-js';
import { t } from '../i18n';
import { tierLabelKey } from '../lib/keyModels';
import type { KeyModelRow } from '../lib/keys';

// The tier tags a key carries, on its card (arc 101 slice 02). This is what
// makes the round trip PROVABLE: a maintainer tags a model at capture and the
// card shows the same tag came back from the SERVER — a stored field nothing
// renders is a dead producer, this repo's most recurrent defect class.
//
// TAGGED rows only, and the filtering is a per-row `<Show>` rather than a
// `.filter()` over the list. `<For/>` renders nothing for an absent list, so
// this needs no `?? []` and states no fallback the contract does not have:
// every masked row carries `models` (a capture that tags nothing still writes
// one untagged row equal to `model`, which the card's identity line already
// shows — repeating it under a "tags" heading would say one fact twice).

export type KeyModelTagsProps = {
  readonly models: readonly KeyModelRow[];
};

export function KeyModelTags(props: KeyModelTagsProps): JSX.Element {
  return (
    <ul class="key-card__tag-list" aria-label={t('account_keys.tagged_models')}>
      <For each={props.models}>
        {(row) => (
          <Show when={row.tier}>
            {(tier) => (
              <li class="badge badge--outline key-card__tag" data-tier={tier()}>
                <span class="key-card__tag-model">{row.model}</span>
                <span>{t(tierLabelKey(tier()))}</span>
              </li>
            )}
          </Show>
        )}
      </For>
    </ul>
  );
}
